'use client'

import { useEffect } from 'react'
import { useRouter, useSearchParams, usePathname } from 'next/navigation'

/**
 * Cleans up _rsc parameter from URL if it appears in browser address bar
 */
export function CleanupRscUrl() {
  const router = useRouter()
  const searchParams = useSearchParams()
  const pathname = usePathname()

  useEffect(() => {
    if (searchParams.has('_rsc')) {
      const newParams = new URLSearchParams(searchParams)
      newParams.delete('_rsc')

      const queryString = newParams.toString()
      const newUrl = queryString ? `${pathname}?${queryString}` : pathname

      // Replace current URL without adding to history
      router.replace(newUrl)
    }
  }, [searchParams, pathname, router])

  return null
}
